import Axios from 'axios';
import{AxiosProcessor} from '../../shared/axios/AxiosProcessor';
const urlCognito = '/cognitoUser';

const state = {
    cognitoUser: {}
};

const getters = {
    getCognitoUser: state => {
        return state.cognitoUser;
    }
};

const mutations = {
    setCognitoUser: (state, data) => {
        state.cognitoUser = data;
    }
};

const actions = {
    async setCognitoUser ({commit}, data) {
        //going backend
        let value = {};

        if(data.update) {
            value = await AxiosProcessor.put(urlCognito+'/'+ data.username, data);
        }
        else {
            value = await AxiosProcessor.post(urlCognito, data);
        }

        commit('setCognitoUser', value);
    },
    async getCognitoUser ({commit}, data) {
        let value = {};

        value = await AxiosProcessor.get(urlCognito+'/'+data.username);

        commit('setCognitoUser', value);
    },
    async deleteCognitoUser ({commit}, data){
        //going backend,
        let value = {};

        value = await AxiosProcessor.delete(urlCognito+'/'+data.username);

        commit('setCognitoUser', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}